import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 8px;
  background: white;
  border: 1px solid #e4e3e2;
`;

const Title = styled.p`
  margin: 0;
  color: rgba(0, 0, 0, 0.75);
  font-size: 13px;
  font-weight: 600;
`;

const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Swatch = styled.span`
  display: inline-block;
  width: 24px;
  height: 14px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: ${({ color }) => color || "transparent"};
  flex-shrink: 0;
`;

const Label = styled.span`
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
`;

function ColorLegend({ items, title, className }) {
  const list = Array.isArray(items)
    ? items.filter(item => item && item.color && item.label)
    : [];

  if (!list.length) return null;

  return (
    <Root className={className}>
      {title ? <Title>{title}</Title> : null}
      <Items>
        {list.map((item, index) => (
          <Item
            key={item.id != null ? String(item.id) : `${item.color}-${index}`}
          >
            <Swatch color={item.color} aria-hidden />
            <Label>{item.label}</Label>
          </Item>
        ))}
      </Items>
    </Root>
  );
}

ColorLegend.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      color: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  title: PropTypes.string,
  className: PropTypes.string
};

ColorLegend.defaultProps = {
  items: [],
  title: undefined,
  className: undefined
};

export default ColorLegend;
